import { MapperHelper } from '~src/spacesPlatform/models/mappers/MapperHelper';

import { IContentRelayPlanInfo } from '../models/IContentRelayPlanInfo';
import { IContentRelayPlan } from '../serverApi/types/IContentRelayPlan';

export module ContentRelayPlanMapper {

  export function map(plans: IContentRelayPlan[]): IContentRelayPlanInfo[] {
    if (!plans || plans.length === 0) {
      return [];
    }
    return plans.map(mapOne);
  }

  function mapOne(plan: IContentRelayPlan): IContentRelayPlanInfo {
    return {
      id: plan.id + '',
      luid: plan.luid,
      name: plan.name,
      description: plan.description,
      contentType: 'contentRelayPlan',
      // Plans are not favoritable in this list-only view; listPlans returns no favorite state.
      favorite: false,
      ownerId: plan.ownerId != null ? plan.ownerId + '' : undefined,
      modifiedByUserId: plan.modifiedByUserId != null ? plan.modifiedByUserId + '' : undefined,
      destinationSiteLuid: plan.destinationSiteLuid,
      destinationSiteName: plan.destinationSiteName,
      destinationServerUrl: plan.destinationServerUrl,
      state: plan.state,
      createdAt: MapperHelper.toDate(plan.createdAt),
      updatedAt: MapperHelper.toDate(plan.updatedAt),
    };
  }
}
